module.exports = __webpack_public_path__ + "img/society5.b9825097.jpg";